<template>
  <div class="cart-shipping-promo">
    <div
      class="cart-shipping-promo__text text-center xs"
      v-html="text"
    /> 
    <div
      v-if="!customerHasEarnedFreeDelivery"
      class="cart-shipping-promo__success-bar"
    >
      <div :style="{ width: percentageSuccessForFreeDelivery }" />
    </div>
  </div>
</template>

<script>
import { productPrice } from '../../helpers/product'

export default {
  props: {
    cartTotalPrice: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      freeShipping: { ...window.theme.cart.freeShipping }
    }
  },
  computed: {
    freeDeliveryThreshold () {
      return this.freeShipping.freeDeliveryThreshold * 100
    },
    customerHasEarnedFreeDelivery () {
      return this.cartTotalPrice >= this.freeDeliveryThreshold
    },
    remainingSpendForFreeDelivery () {
      return this.freeDeliveryThreshold - this.cartTotalPrice
    },
    remainingSpendForFreeDeliveryPrice () {
      return productPrice(this.remainingSpendForFreeDelivery)
    },
    percentageSuccessForFreeDelivery () {
      return `${100 / this.freeDeliveryThreshold * this.cartTotalPrice}%`
    },
    freeDeliveryPromoText () {
      return this.freeShipping.freeDeliveryPromoText.replace('[AMOUNT]', this.remainingSpendForFreeDeliveryPrice)
    },
    text () {
      return this.customerHasEarnedFreeDelivery ? this.freeShipping.freeDeliverySuccessText : this.freeDeliveryPromoText
    }
  }
}
</script>
